import type { HelpSource, HelpUIMessage } from './types'

type Part = HelpUIMessage['parts'][number]

const isTextPart = (part: Part): part is Extract<Part, { type: 'text' }> =>
  part.type === 'text'

const isSourcesPart = (
  part: Part,
): part is Extract<Part, { type: 'data-sources' }> =>
  part.type === 'data-sources'

export function messageText(message: HelpUIMessage): string {
  return message.parts
    .filter(isTextPart)
    .map((part) => part.text)
    .join('')
}

export function messageSources(message: HelpUIMessage): HelpSource[] {
  const parts = message.parts.filter(isSourcesPart)
  const last = parts[parts.length - 1]
  return last ? last.data : []
}

export function lastAssistantSources(messages: HelpUIMessage[]): HelpSource[] {
  const assistant = [...messages]
    .reverse()
    .find((message) => message.role === 'assistant')
  return assistant ? messageSources(assistant) : []
}
